import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  getBiller,
  billerUpdate,
  billerArchive,
} from '../../redux/actions/billers';
import { getListService } from '../../redux/actions/serviceBiller';
import { getListForm } from '../../redux/actions/forms';
import { getListTnc } from '../../redux/actions/tnc';
import { getListBank } from '../../redux/actions/banks';
import {
  getListPaymentMethod,
  getBlacklistPaymentMethodInBillers,
} from '../../redux/actions/paymentMethods';
import BillerUpdate from './BillerUpdate.page';

const mapStateToProps = state => ({
  listTnc: state.allbiller.tncList,
  listService: state.allbiller.listService,
  listForm: state.allbiller.listForm,
  biller: state.allbiller.biller,
  listBank: state.allbiller.listBank,
  listPaymentMethod: state.allbiller.listPaymentMethod,
  blacklistPaymentMethodInBillers:
    state.allbiller.blacklistPaymentMethodInBillers,
  loading: state.allbiller.loading,
});

const mapDispatchToProps = {
  getBiller,
  getListTnc,
  getListService,
  getListForm,
  getListBank,
  getListPaymentMethod,
  getBlacklistPaymentMethodInBillers,
  billerUpdate,
  billerArchive,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(BillerUpdate));
